export default __webpack_public_path__ + "static/media/powered_logo1.a4e483ee.png";